import { useState } from "react";
import { num } from "@/lib/format";
import { Progress } from "@/components/ui/progress";
import { ChevronDown, ChevronRight } from "lucide-react";

export const PairRow = ({ r, idx }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={`pair-item-${idx}`}>
      <button onClick={() => setOpen(!open)} className="w-full text-left" data-testid={`pair-toggle-${idx}`}>
        <div className="mb-1 flex items-center justify-between gap-3 text-sm">
          <span className="flex min-w-0 items-center gap-1 font-medium">
            {open ? <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" /> : <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />}
            <span className="truncate">{r.name}</span>
          </span>
          <span className="shrink-0 font-mono-erp text-xs text-muted-foreground">
            {num(r.returned)} tornati su {num(r.customers)} · <span className="font-semibold text-foreground">{r.rate}%</span>
          </span>
        </div>
        <Progress value={r.rate} className="h-2" />
      </button>
      {open && (
        <div className="ml-5 mt-2 space-y-1 border-l border-border/60 pl-3" data-testid={`pair-next-${idx}`}>
          {r.next.length ? r.next.map((n) => (
            <p key={n.name} className="flex justify-between text-xs">
              <span className="text-muted-foreground">→ {n.name}</span>
              <span>{num(n.customers)} {n.customers === 1 ? "cliente" : "clienti"} · {num(n.units)} pz</span>
            </p>
          )) : <p className="text-xs text-muted-foreground">Nel secondo ordine nessun capo della stagione.</p>}
        </div>
      )}
    </div>
  );
};
